import './signers.scss'

import { PropType } from "vue"
import Component from "vue-class-component"
import { faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons'

import { Signer as SignerType } from "@skinsoft/types"

import { ReactiveVue } from "@skinsoft/reactive-vue"
import { ADD_SIGNER, REMOVE_SIGNER, SIGNER_UPDATED } from "../../../../busTopics"
import { Signer } from "./signer"

@Component({
    components: {
        sSigner: Signer,
    },
    props: {
        type: Array,
        form: {},
        fieldName: {},
        signers: {
            type: Array as PropType<SignerType[]>,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: 'editReportScreen.reportContext.reportDoneInThePresenceOf'
        },
        showDate: {
            type: Boolean,
            default: false,
        },
    },
    template: require("./signers.html")
})
export class Signers extends ReactiveVue {

    private SIGNER_UPDATED = SIGNER_UPDATED

    public plusIcon = faPlusCircle
    public minusIcon = faTrash

    private onSignerUpdated(updatedSigner: SignerType, index: number) {
        this.$emit(SIGNER_UPDATED, [updatedSigner, index])
    }

    private removeSigner(index: number) {
        this.$emit(REMOVE_SIGNER, index)
    }

    private addSigner() {
        this.$emit(ADD_SIGNER)
    }
}